/* HOMIRA — theme behaviour: drawers, cart, accordions, galleries, carousels. */
(function () {
  'use strict';
  var R = (window.HOMIRA && window.HOMIRA.routes) || {};

  /* ── drawers ─────────────────────────────────────────────────────────── */
  function drawer(name) { return document.querySelector('[data-hm-drawer="' + name + '"]'); }
  function scrim(name) { return document.querySelector('[data-hm-scrim="' + name + '"]'); }

  function openDrawer(name) {
    var d = drawer(name), s = scrim(name);
    if (!d) return;
    d.setAttribute('data-open', '');
    if (s) s.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    if (name === 'cart') startTimer();
  }
  function closeDrawers() {
    document.querySelectorAll('[data-hm-drawer],[data-hm-scrim]').forEach(function (el) { el.removeAttribute('data-open'); });
    document.body.style.overflow = '';
  }
  window.HOMIRA_openCart = function () { openDrawer('cart'); };

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-hm-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-hm-open')); return; }
    if (e.target.closest('[data-hm-close]') || e.target.closest('[data-hm-scrim]')) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ── cart ────────────────────────────────────────────────────────────── */
  function refreshCart() {
    return fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-hm-drawer="cart"]');
        var current = drawer('cart');
        if (fresh && current) {
          var wasOpen = current.hasAttribute('data-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.setAttribute('data-open', '');
        }
        return fetch(R.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-hm-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('homira:cart:updated', { detail: cart }));
        return cart;
      });
  }

  function addToCart(items, opts) {
    opts = opts || {};
    return fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart');
        return refreshCart();
      })
      .then(function (cart) { if (opts.open !== false) openDrawer('cart'); return cart; });
  }
  window.HOMIRA_add = addToCart;

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-hm-qty]');
    if (q) {
      var row = q.closest('div');
      var span = q.parentElement.querySelector('span');
      var current = span ? parseInt(span.textContent.trim(), 10) : 1;
      var next = current + parseInt(q.getAttribute('data-delta'), 10);
      changeLine(q.getAttribute('data-hm-qty'), Math.max(0, next));
      return;
    }
    var rm = e.target.closest('[data-hm-remove]');
    if (rm) { changeLine(rm.getAttribute('data-hm-remove'), 0); }
  });

  function changeLine(key, quantity) {
    fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCart);
  }

  /* ── ATC forms ───────────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-hm-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    var items = [];
    var main = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    if (main && main.value) items.push({ id: Number(main.value), quantity: Number((qty && qty.value) || 1) });
    form.querySelectorAll('[data-hm-extra-id]').forEach(function (el) {
      if (el.value) items.push({ id: Number(el.value), quantity: Number(el.getAttribute('data-hm-qty-extra') || 1) });
    });
    addToCart(items)
      .catch(function (err) {
        var note = form.querySelector('[data-hm-atc-error]');
        if (note) { note.textContent = err.message; note.style.display = 'block'; }
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* ── reservation timer ───────────────────────────────────────────────── */
  var timerHandle = null;
  function startTimer() {
    var el = document.querySelector('[data-hm-timer]');
    if (!el || timerHandle) return;
    var left = (parseInt(el.getAttribute('data-minutes'), 10) || 10) * 60;
    timerHandle = setInterval(function () {
      var node = document.querySelector('[data-hm-timer]');
      if (!node) return;
      left = left > 0 ? left - 1 : (parseInt(node.getAttribute('data-minutes'), 10) || 10) * 60;
      node.textContent = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
    }, 1000);
  }

  /* ── accordions ──────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-hm-acc]');
    if (!head) return;
    var panel = head.nextElementSibling;
    var open = head.getAttribute('aria-expanded') === 'true';
    var group = head.closest('[data-hm-acc-group]');
    if (group && !open) {
      group.querySelectorAll('[data-hm-acc][aria-expanded="true"]').forEach(function (h) {
        h.setAttribute('aria-expanded', 'false');
        if (h.nextElementSibling) h.nextElementSibling.style.display = 'none';
        var s = h.querySelector('[data-hm-acc-sign]'); if (s) s.textContent = '+';
      });
    }
    head.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.style.display = open ? 'none' : 'block';
    var sign = head.querySelector('[data-hm-acc-sign]');
    if (sign) sign.textContent = open ? '+' : '−';
  });

  /* ── horizontal carousels ────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hm-scroll]');
    if (!b) return;
    var track = document.getElementById(b.getAttribute('data-hm-scroll-target'));
    if (!track) return;
    track.scrollBy({ left: (b.getAttribute('data-hm-scroll') === 'prev' ? -1 : 1) * Math.max(280, track.clientWidth * 0.8), behavior: 'smooth' });
  });

  /* ── product gallery ─────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hm-thumb]');
    if (!t) return;
    var gal = t.closest('[data-hm-gallery]');
    if (!gal) return;
    var idx = t.getAttribute('data-hm-thumb');
    gal.querySelectorAll('[data-hm-main]').forEach(function (m) {
      m.style.display = m.getAttribute('data-hm-main') === idx ? 'block' : 'none';
    });
    gal.querySelectorAll('[data-hm-thumb]').forEach(function (x) {
      x.style.borderColor = x === t ? 'var(--color-text)' : 'transparent';
    });
    var counter = gal.querySelector('[data-hm-counter]');
    if (counter) counter.textContent = (Number(idx) + 1) + ' / ' + gal.querySelectorAll('[data-hm-thumb]').length;
  });

  /* ── variant picker ──────────────────────────────────────────────────── */
  document.querySelectorAll('[data-hm-variants]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-hm-variant-json]').textContent);
    var idInput = root.querySelector('[name="id"]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-hm-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function update() {
      var want = selected();
      var match = data.find(function (v) {
        return v.options.every(function (o, i) { return want[i] == null || o === want[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      root.querySelectorAll('[data-hm-price]').forEach(function (el) { el.innerHTML = match.price_html; });
      root.querySelectorAll('[data-hm-compare]').forEach(function (el) { el.innerHTML = match.compare_html || ''; el.style.display = match.compare_html ? '' : 'none'; });
      root.querySelectorAll('[data-hm-availability]').forEach(function (el) { el.textContent = match.available ? el.getAttribute('data-in') : el.getAttribute('data-out'); });
      var btn = root.querySelector('[data-hm-atc-button]');
      if (btn) { btn.disabled = !match.available; btn.querySelector('[data-hm-atc-label]') && (btn.querySelector('[data-hm-atc-label]').textContent = match.available ? btn.getAttribute('data-in') : btn.getAttribute('data-out')); }
      if (match.featured_media_position != null) {
        var gal = document.querySelector('[data-hm-gallery]');
        if (gal) {
          var t = gal.querySelector('[data-hm-thumb="' + match.featured_media_position + '"]');
          if (t) t.click();
        }
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input')) update(); });
    update();
  });

  /* ── product card swatches ───────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-hm-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-hm-card]');
    if (!card) return;
    var value = sw.getAttribute('data-hm-card-swatch');
    var idxEl = card.querySelector('[data-hm-card-colour-index]');
    var idx = idxEl ? Number(idxEl.getAttribute('data-hm-card-colour-index')) : -1;
    var json = card.querySelector('[data-hm-card-variants]');
    if (idx < 0 || !json) return;
    var variants = JSON.parse(json.textContent);
    var match = variants.find(function (v) { return v.options[idx] === value; });
    if (!match) return;
    var input = card.querySelector('[data-hm-card-id]');
    if (input) input.value = match.id;
    if (match.image) { var im = card.querySelector('[data-hm-card-image]'); if (im) im.src = match.image; }
    var note = card.querySelector('[data-hm-card-colour-note]');
    if (note) note.textContent = note.textContent.indexOf('·') > -1 ? value + note.textContent.slice(note.textContent.indexOf(' ·')) : value;
    card.querySelectorAll('[data-hm-card-swatch]').forEach(function (x) {
      x.style.boxShadow = x === sw ? '0 0 0 2px #fff inset, 0 0 0 2px var(--color-accent)' : 'none';
    });
  });

  /* ── collection colour filter ────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hm-filter]');
    if (!b) return;
    var value = b.getAttribute('data-hm-filter');
    var scope = b.closest('[data-hm-filter-scope]') || document;
    scope.querySelectorAll('[data-hm-filter]').forEach(function (x) {
      var on = x === b;
      x.style.background = on ? 'var(--color-text)' : 'transparent';
      x.style.color = on ? '#fff' : 'var(--color-text)';
    });
    document.querySelectorAll('[data-hm-card-colours]').forEach(function (card) {
      var list = (card.getAttribute('data-hm-card-colours') || '').toLowerCase();
      card.style.display = (value === '*' || list.indexOf(value.toLowerCase()) > -1) ? '' : 'none';
    });
  });
})();
